import { create, read, remove, update } from '@/api/rest';

const volunteeringPeriod = {
  create: async (data) => await create('/volunteering-period', data),
  index: async (params = {}) => await read('/volunteering-period', { params }),
  update: async (id, data) => await update(`/volunteering-period/${id}`, data),
  remove: async (id) => await remove(`/volunteering-period/${id}`),
  events: async (params = {}) =>
    await read('/volunteering-period/events', { params }),
};

export default volunteeringPeriod;
